import { ISection } from '../../../../interfaces/scheduler_interfaces';
import { TermProgramInfoModel } from '../../../term_courses/models/term_program_info_model';

import * as _4 from 'lodash4';
import { RegistrationFacade } from '../../../registration/facades/registration_facade';
import { RegistrationOneClickQuery } from '../../../registration/queries/registration_one_click_query';
import { RequestStateQuery } from '../../../../request_state/queries/request_state_query';

class RegisterSectionsButton {
  private registerAction: () => void;

  constructor(
    private ngTermProgramInfoModel: TermProgramInfoModel,
    private ngRegistrationFacade: RegistrationFacade,
    private ngRegistrationOneClickQuery: RegistrationOneClickQuery,
    private ngRequestStateQuery: RequestStateQuery
  ) {}

  $onInit() {
    this.ngRegistrationFacade.reCalculateFlags();
  }

  $onChanges(changes: { section: ISection }) {
    this.ngRegistrationFacade.reCalculateFlags();
  }

  isValidRegistrationPeriod(): boolean {
    const termInfo = this.ngTermProgramInfoModel.read();
    const registrationStart = _4.get(termInfo, 'term.registration_start_dt', '');
    const registrationEnd = _4.get(termInfo, 'term.registration_end_dt', '');
    const registrationStartDate = moment(registrationStart.split(',')[0], 'MM-DD-YYYY').toDate();
    const registrationEndDate = moment(registrationEnd.split(',')[0], 'MM-DD-YYYY').toDate();

    return moment(moment()).isBetween(registrationStartDate, registrationEndDate);
  }
}

class RegisterSectionsButtonComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;
  constructor() {
    this.bindings = {
      registerAction: '&'
    };
    this.controller = RegisterSectionsButton;
    this.templateUrl =
      'capability-ng-scheduler/src/views/course_scheduler/components/register_sections_button/register_sections_button.html';
  }
}
angular.module('capability-ng-scheduler').component('registerSectionsButton', new RegisterSectionsButtonComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/components/register_sections_button/register_sections_button.ts